import { fetchArtifactBlob } from '@hooks/useModelBlob';

export interface AppFramePage {
  /** Names the bytes: the page asset, stable however the screen got to it. */
  readonly key: string;
  readonly load: () => Promise<string>;
}

export const apiPage = (url: string, key: string): AppFramePage => ({
  key,
  load: async () => (await fetchArtifactBlob(url, true, { acceptHtml: true, skipAuthRedirect: true })).text(),
});
